import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { ListItemSongComponent } from './list-item-song.component';

@NgModule({
    imports: [ CommonModule, FormsModule, IonicModule],
    declarations: [ListItemSongComponent],
    exports: [ListItemSongComponent]
})
export class ListItemSongComponentModule {}
